import { SiteData, SiteSettings } from '../types';

/**
 * Replaces dynamic placeholders such as {{business.name}}, {{business.phone}}, {{business.email}},
 * {{business.address}}, {{business.whatsapp}}, {{business.working_hours}}, {{business.city}}
 * with real, live database values from the site configuration.
 */
export function interpolateBusinessTokens(
  templateText: string | undefined,
  siteData?: Partial<SiteData>
): string {
  if (!templateText) return '';
  if (!siteData) return templateText;

  const s = siteData.settings || {};
  const businessName = s.businessName || siteData.name || 'İşletmeniz';
  const phone = s.phone || '+90 (212) 800 00 00';
  const email = s.email || 'info@isletmeniz.com';
  const address = s.address || 'İstanbul / Türkiye';
  const whatsapp = s.whatsapp || phone;
  const workingHours = s.workingHours || 'Pzt - Cmt: 08:30 - 19:30';
  const city = s.city || 'İstanbul';
  const district = s.district || 'Merkez';
  const tagline = s.tagline || s.shortDescription || '';
  const foundedYear = s.foundedYear ? String(s.foundedYear) : '2015';

  return templateText
    .replace(/\{\{\s*business\.name\s*\}\}/gi, businessName)
    .replace(/\{\{\s*business\.phone\s*\}\}/gi, phone)
    .replace(/\{\{\s*business\.email\s*\}\}/gi, email)
    .replace(/\{\{\s*business\.address\s*\}\}/gi, address)
    .replace(/\{\{\s*business\.whatsapp\s*\}\}/gi, whatsapp)
    .replace(/\{\{\s*business\.working_hours\s*\}\}/gi, workingHours)
    .replace(/\{\{\s*business\.workingHours\s*\}\}/gi, workingHours)
    .replace(/\{\{\s*business\.city\s*\}\}/gi, city)
    .replace(/\{\{\s*business\.district\s*\}\}/gi, district)
    .replace(/\{\{\s*business\.tagline\s*\}\}/gi, tagline)
    .replace(/\{\{\s*business\.founded_year\s*\}\}/gi, foundedYear)
    .replace(/\{\{\s*business\.foundedYear\s*\}\}/gi, foundedYear)
    .replace(/\{\{\s*business\.social\.instagram\s*\}\}/gi, s.socialLinks?.instagram || '')
    .replace(/\{\{\s*business\.social\.facebook\s*\}\}/gi, s.socialLinks?.facebook || '')
    .replace(/\{\{\s*business\.social\.linkedin\s*\}\}/gi, s.socialLinks?.linkedin || '')
    .replace(/\{\{\s*business\.social\.whatsapp\s*\}\}/gi, s.socialLinks?.whatsapp || whatsapp);
}

/**
 * Format phone string cleanly for tel: protocol
 */
export function formatPhoneForTel(phone?: string): string {
  if (!phone) return '+902128000000';
  return phone.replace(/[^\d+]/g, '');
}

/**
 * Format phone string cleanly for WhatsApp wa.me link
 */
export function formatPhoneForWhatsApp(whatsappOrPhone?: string, customMessage?: string): string {
  if (!whatsappOrPhone) return 'https://wa.me/905321234567';
  const cleanNumber = whatsappOrPhone.replace(/[^\d]/g, '');
  const msg = customMessage ? `?text=${encodeURIComponent(customMessage)}` : '';
  return `https://wa.me/${cleanNumber}${msg}`;
}
